import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { API, useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, refresh } = useAuth();
  const [st, setSt] = useState({ status: "loading" });
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setSt({ status: "error", msg: "Link non valido" }); return; }
    axios.get(`${API}/auth/verify-email`, { params: { token } }).then(r => { setSt({ status: "ok", ...r.data }); refresh?.(); }).catch(e => setSt({ status: "error", msg: e.response?.data?.detail || "Link non valido o scaduto" }));
  }, []);
  return (
    <div className="min-h-screen grain-bg"><Navbar />
      <section className="pt-32 pb-24 max-w-lg mx-auto px-5 text-center" data-testid="verify-email-page">
        {st.status === "loading" && <div className="text-slate-500">Verifica in corso…</div>}
        {st.status === "ok" && <div className="rl-card p-8">
          <div className="pill-badge pill-amber mb-3">EMAIL CONFERMATA</div>
          <h1 className="font-display font-black text-3xl md:text-5xl mb-3" data-testid="verify-ok">Sei ufficialmente in griglia.</h1>
          <p className="text-slate-400 text-sm mb-6">{st.granted ? `+${st.granted} Rally Credits bonus sbloccati nel tuo Rally Wallet.` : st.already ? "Questa email era già confermata." : "Da ora bonus invito e First Grid Bonus vengono accreditati automaticamente."}</p>
          <Link to={user ? (localStorage.getItem("rl_next") || "/community") : `/login?next=${encodeURIComponent(localStorage.getItem("rl_next") || "/community")}`} onClick={() => localStorage.removeItem("rl_next")} className="btn-crimson min-h-[44px] inline-flex items-center" data-testid="verify-continue-btn">{localStorage.getItem("rl_next") === "/farm" ? "VAI A RALLY FARM" : "CONTINUA"}</Link>
        </div>}
        {st.status === "error" && <div className="rl-card p-8">
          <h1 className="font-display font-black text-3xl mb-3" data-testid="verify-error">Link non valido</h1>
          <p className="text-slate-400 text-sm mb-6">{st.msg}. Puoi richiedere un nuovo invio dalla tua Area Community.</p>
          <Link to="/community" className="btn-outline-rl">AREA COMMUNITY</Link>
        </div>}
      </section>
    </div>
  );
}
